import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"mr-3"},[_vm._v(_vm._s(_vm.title))]),_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c(VIcon,_vm._g(_vm._b({attrs:{"color":"primary","dark":""}},'v-icon',attrs,false),on),[_vm._v("\n        mdi-information\n      ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.description)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }